import React from 'react';


export const TextOnlyLogo = ({ color = '#92004d' }) => (
	<svg
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		width="100%"
		viewBox="-40 -13.6 100 46.3"
		enableBackground="new -40 -13.6 100 46.3"
		xmlSpace="preserve"
	>
		<path
			fill={ color }
			d="M-13.6-0.1c-1.3-1-2.8-1.4-5.4-1.8c-1.4-0.1-6.7-0.1-21,0v34.5h9.3v-9.1c1.9,0.7,4,1.4,5.4,1.7
	c1.5,0.4,3.1,0.6,4.5,0.6c2.5,0.1,3.6-0.3,5.4-0.8c3.6-1.3,4.9-4,5.6-6.7c1.1-4.3,1-9.5-0.1-13.4C-10.7,3.3-11.9,1-13.6-0.1z
	 M-19.2,15.1c-0.3,1-1,2.6-2.5,3.2c-0.8,0.3-2.1,0.6-2.9,0.6s-1.4,0-1.8-0.1c-1.9-0.1-3.2-0.4-4.3-0.8V4.2c4.7-0.1,7.4,0,7.4,0
	c2.6,0.3,3.6,1.3,4.3,3.6C-18.5,10.1-18.6,13.1-19.2,15.1z M16.4,8.3C20.7,5.9,25,5.3,25,5.3v-7.7c0,0-3.5,0.7-7.2,2.4
	c-5,2.1-8.5,4.9-9.5,5.6S6.5,6.9,5.6,7.6V-13h-9.5v38.6h9.5V13.7l9.1,11.8h12.4L13,10.4C14,9.7,14.8,9.1,16.4,8.3z M38.6-1.9
	c-2.6,0.3-4,0.8-5.4,1.8c-1.5,1.3-2.9,3.3-3.3,5.2c-1,3.9-1.1,9.1,0.3,13.4c0.8,2.6,2.1,5.8,5.7,7.1c1.5,0.6,2.8,0.8,4.9,0.7
	c1.4-0.1,3.5-0.7,5-1.1c1.5-0.4,3.1-1,5-1.7v2.1H60V-1.9C45.9-2,40-2.2,38.6-1.9z M50.8,17.9c-1.5,0.4-3.6,0.8-6,1
	c-0.8,0-2.1-0.1-2.9-0.6c-1.5-0.6-2.2-2.2-2.6-3.2c-0.6-1.9-0.8-5-0.3-7.2c0.6-2.2,1.8-3.5,4.2-3.6c0,0,2.9-0.1,7.7,0V17.9z"
		/>
	</svg>
);

/**
 * Bruges her med fowardRef så framer motion kan
 * bruge den.
 */
export const MenuIcon = React.forwardRef<SVGSVGElement>(
	(props, ref) => (
		<svg
			ref={ ref }
			width="30"
			height="30"
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="6" y="6" width="4" height="4" fill="#CE0060" />
			<rect x="13" y="6" width="4" height="4" fill="#CE0060" />
			<rect x="20" y="6" width="4" height="4" fill="#CE0060" />
			<rect x="6" y="13" width="4" height="4" fill="#CE0060" />
			<rect x="6" y="20" width="4" height="4" fill="#CE0060" />
			<rect x="13" y="13" width="4" height="4" fill="#CE0060" />
			<rect x="13" y="20" width="4" height="4" fill="#CE0060" />
			<rect x="20" y="13" width="4" height="4" fill="#CE0060" />
			<rect x="20" y="20" width="4" height="4" fill="#CE0060" />
		</svg>

	)
);

MenuIcon.displayName = 'MotionMenuIcon';
